import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            searchQuery: "",
            activeSearch: "",
            nowTs: Date.now(),
            useFocusForScannerTimedSlot: false,
            timedSlots: [],
            warnMs: 20 * 60 * 1000,
            intervalId: null,
            addingMode: false,
            fromDate : null,
            newTimedSlot: {
                name: '',
                capacity: 0
            },
            updateTimedSlot: {
                id: 0,
                name: '',
                capacity: 0
            },
            slotToAdd: null,
            slotToChooseShopItem: null,
            interval: null,
            barcode: '',
            timeout: null,
            focusedSlotItem: -1
        }
    },
    computed: {
        filteredSlots() {
            // return this.timedSlots;
            if (!this.activeSearch) return this.timedSlots

            const q = this.activeSearch.toLowerCase()
            return this.timedSlots.map(slot => {
                return {
                    slot: slot.slot,
                    items: slot.items.filter(item =>
                        (item.username && item.username.toLowerCase().includes(q)) ||
                        (item.firstName && item.firstName.toLowerCase().includes(q)) ||
                        (item.lastName && item.lastName.toLowerCase().includes(q))
                    ),
                    historyItems: slot.historyItems.filter(item =>
                        (item.username && item.username.toLowerCase().includes(q)) ||
                        (item.firstName && item.firstName.toLowerCase().includes(q)) ||
                        (item.lastName && item.lastName.toLowerCase().includes(q))
                    ),
                }
            })
        }
    },
    methods: {
        load: load,
        addNewTimedSlot: addNewTimedSlot,
        cancelAddNewTimedSlot: cancelAddNewTimedSlot,
        onExtend: onExtend,
        onEditTimedSlot: onEditTimedSlot,
        onCancelEditTimedSlot: onCancelEditTimedSlot,
        editNewTimedSlot: editNewTimedSlot,
        onDeleteTimedSlot: onDeleteTimedSlot,
        addUserToSlotTime: addUserToSlotTime,
        slotCheckIn: slotCheckIn,
        slotCheckOut: slotCheckOut,
        keymonitor: keymonitor,
        getExtensions: getExtensions,
        qrScanListener: qrScanListener,
        onClickSlotItemFocus: onClickSlotItemFocus,
        slotCheckInWithUsername: slotCheckInWithUsername,
        addShopItemToSession: addShopItemToSession,
        addShopItem: addShopItem,
        getAdditionals: getAdditionals,
        checkIfHaveExpired: checkIfHaveExpired,
        onSearch() {
            this.activeSearch = this.searchQuery.trim()
        },
        clearSearch() {
            this.searchQuery = ""
            this.activeSearch = ""
        },
        busyCount(slot) {
            if (
                slot.slot &&
                slot.slot.busyNumber !== null &&
                slot.slot.busyNumber !== undefined
            ) {
                return slot.slot.busyNumber;
            }
            return (slot.items || []).filter((i) => !i.actualEndAt).length;
        },
        progressPct(slot) {
            const cap = slot.slot.capacity || 0;
            const busy = this.busyCount(slot);
            if (!cap) return 0;
            return Math.max(0, Math.min(100, Math.round((busy / cap) * 100)));
        },
        capacityTitle(slot) {
            return `${LocService.t('label_capacity_progress')}: ${this.busyCount(slot)}/${slot.slot.capacity}`;
        },

        parseIso(zdt) {
            return zdt ? new Date(zdt).getTime() : null;
        },
        fmt(zdt) {
            const ts = this.parseIso(zdt);
            if (!ts) return "—";
            const d = new Date(ts);
            const hh = String(d.getHours()).padStart(2, "0");
            const mm = String(d.getMinutes()).padStart(2, "0");
            return `${hh}:${mm}`;
        },
        remainingMs(item) {
            const endTs =
                this.parseIso(item.actualEndAt) || this.parseIso(item.plannedEndAt);
            if (!endTs) return null;
            return endTs - this.nowTs;
        },
        formatDuration(ms) {
            const neg = ms < 0;
            const abs = Math.abs(ms);
            const totalSec = Math.floor(abs / 1000);
            const h = Math.floor(totalSec / 3600);
            const m = Math.floor((totalSec % 3600) / 60);
            const s = totalSec % 60;
            const hh = h > 0 ? `${h}:` : "";
            const mm = h > 0 ? String(m).padStart(2, "0") : String(m);
            const ss = String(s).padStart(2, "0");
            return (neg ? "-" : "") + (hh ? `${hh}${mm}:${ss}` : `${mm}:${ss}`);
        },
        remainingLabel(item) {
            const ms = this.remainingMs(item);
            if (ms === null) return "—";
            if (ms < 0) return `${LocService.t('label_expired')}: ${this.formatDuration(ms)}`;
            return `${LocService.t('label_rest')}: ${this.formatDuration(ms)}`;
        },

        statusClass(item) {
            const ms = this.remainingMs(item);
            if (ms === null) return "";
            if (ms < 0) return "overdue";
            if (ms <= this.warnMs) return "warning";
            return "";
        },
        progressColor(slot) {
            const pct = this.progressPct(slot)
            if (pct >= 90) return "red"
            if (pct >= 70) return "orange"
            return "blue"
        }
    },

    mounted() {
        let _self = this;
        // this.timedSlots = this.mockTimedSlots();
        this.intervalId = setInterval(() => {
            this.nowTs = Date.now();
            _self.checkIfHaveExpired();
        }, 1000);
    },

    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.slotToAdd = null;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            let userId = data.id;
            let slotId = _self.slotToAdd.id;
            _self.slotToAdd = null;
            _self.slotCheckIn(userId , slotId)

        });

        this.$topnavbar.$on('closeChooseShopItem', () => {
            _self.slotToChooseShopItem = null;
        });

        this.$topnavbar.$on('onShopItemSelected', (data) => {
            let userId = _self.slotToChooseShopItem.userId;
            let id = _self.slotToChooseShopItem.id;
            _self.addShopItemToSession(data.orderUuid, userId, id)
            _self.slotToChooseShopItem = null;
        });




        this.useFocusForScannerTimedSlot = session.getConfig().useFocusForScannerTimedSlot != null ? session.getConfig().useFocusForScannerTimedSlot : false;
        if(this.useFocusForScannerTimedSlot){
            let _self = this;
            document.addEventListener('keydown', _self.qrScanListener)
        }
    },

    destroyed() {
        document.removeEventListener('keydown', this.qrScanListener);
    },

    beforeDestroy() {
        if (this.intervalId) clearInterval(this.intervalId);
    },


    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.role = session.getRole();
        this.load()
    },
    watch: {
        searchQuery: function (val, oldVal) {
            if(val == null) {
                this.activeSearch = "";
            }else if(val.length === 0){
                this.activeSearch = "";
            }
        },

        fromDate: function (val, old) {
            this.load();
        }
    }

}

function checkIfHaveExpired(){
    var now = Date.now();

    //da li ima neki koji je prosao 15 i vise minuta, onda povuci podatke
    let hasChange = this.timedSlots.some(s =>
        s.items.some(i =>
            i.status === 'ACTIVE' &&
            now - i.plannedEndAt >=  910000
        )
    );

    if(hasChange){
        this.load();
    }
}

function addShopItem(session){
    this.slotToChooseShopItem = session;
}

function onClickSlotItemFocus(slot){
    if(this.timedSlots.length === 1) return;
    if(!this.useFocusForScannerTimedSlot) return
    if(this.focusedSlotItem === slot.id){
        this.focusedSlotItem = -1
    }else{
        this.focusedSlotItem = slot.id;
    }

}

function qrScanListener(e) {
    let _self = this;

    // Inicijalizacija barcode promenljive ako ne postoji
    if (!_self.barcode) _self.barcode = "";

    // Očisti prethodni timeout ako postoji
    if (_self.timeout) {
        // clearTimeout(_self.timeout);
    }

    // Ako je pritisnut Enter, procesuiraj barcode
    if (e.code === 'Enter') {
        if (_self.barcode) {
            console.log("BARCODE TIMED_SLOT: " + _self.barcode);

            _self.barcode = _self.barcode
                .replaceAll("Shift", "")
                .replaceAll("shift", "")
                .replaceAll("?", "_")
                .replaceAll("CapsLock", "");

            if (_self.barcode.toLowerCase().startsWith("u_")) {
                if(_self.focusedSlotItem === -1){
                    swal(LocService.t('label_error'), LocService.t('label_choose_resource_for_check_in'), 'error')
                    return;
                }else{
                    _self.slotCheckInWithUsername(_self.barcode.substring(2), _self.focusedSlotItem)
                }
            } else {
               //error qr code
            }
        }

        _self.barcode = "";
        return;
    }

    // Dodaj karakter ako nije Shift
    if (e.key != null && e.key.length === 1) {
        _self.barcode += e.key;
    }

    // Postavi timeout da obriše barcode posle 100ms neaktivnosti
    _self.timeout = setTimeout(() => {
        _self.barcode = "";
    }, 100);
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.activeSearch = this.searchQuery;
    }
}

function slotCheckIn(userId, slotId){
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    let model = {
        userId: userId,
        slotTimedId: slotId,
        //TODO samo za test
        durationMinutes: 10
    }
    AdminApiService.checkInSlot(model)
        .then((response) => {
            swal.close();
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function slotCheckInWithUsername(username, slotId){
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    let model = {
        username: username.toLowerCase(),
        slotTimedId: slotId
    }
    AdminApiService.slotCheckInWithUsername(model)
        .then((response) => {
            swal.close();
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function slotCheckOut(slotSession){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_checkout_timed_slot') + ": " + slotSession.firstName + " " + slotSession.lastName + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let model = {
            userId: slotSession.userId,
            slotTimedSessionId: slotSession.id
        }
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {
        });
        AdminApiService.checkOutSlot(model)
            .then((response) => {
                swal.close();
                _self.load();
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function onDeleteTimedSlot(slot){
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_delete_timed_slot') + ": " + slot.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTimedSlot(slot.slot.id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_timed_slot_success_delete'), 'success')
                _self.load();
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function onEditTimedSlot(slot) {
    slot.addingMode = true;
    this.updateTimedSlot = {
        id: slot.slot.id,
        name: slot.slot.name,
        capacity: slot.slot.capacity
    }
}

function onCancelEditTimedSlot(slot) {
    slot.addingMode = false;
    this.updateTimedSlot = {
        id: 0,
        name: '',
        capacity: 0
    }
}

function onExtend(item, slot) {
    let _self = this
    swal({
        title: LocService.t("label_set_number_in_minutes"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="number" placeholder="'+ LocService.t("label_set_number_in_minutes") +'" class="input" style="width: 50%; border-radius: 10px"  />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var minutes = document.getElementById('swal-input').value
        var num = parseInt(minutes)

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        let model = {
            userId: item.userId,
            slotTimedSessionId: item.id,
            durationMinutes: minutes
        }

        AdminApiService.extendSlotTimedSession(model)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function addNewTimedSlot() {
    let _self = this;
    if (this.newTimedSlot.name.length < 0 || this.newTimedSlot.capacity < 0) {
        swal(LocService.t('label_error'), LocService.t('label_error'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    let model = {
        name: this.newTimedSlot.name,
        capacity: this.newTimedSlot.capacity
    }
    AdminApiService.createTimedSlots(model)
        .then((response) => {
            swal.close();
            _self.load();
            _self.onCancelEditTimedSlot()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function editNewTimedSlot() {
    let _self = this;
    if (this.newTimedSlot.name.length < 0 || this.newTimedSlot.capacity < 0) {
        swal(LocService.t('label_error'), LocService.t('label_error'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    let model = {
        id: this.updateTimedSlot.id,
        name: this.updateTimedSlot.name,
        capacity: this.updateTimedSlot.capacity
    }
    AdminApiService.updateTimedSlots(model)
        .then((response) => {
            swal.close();
            _self.load();
            _self.cancelAddNewTimedSlot()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function cancelAddNewTimedSlot() {
    this.addingMode = false
    this.newTimedSlot = {
        name: '',
        capacity: 0
    }
}

function addUserToSlotTime(slot){
    this.slotToAdd = slot.slot
}

function load() {
    let _self = this;

    var model = {
        date : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
    }
    AdminApiService.getTimedSlots(model)
        .then((response) => {
            response.data.forEach(i => {
                i.addingMode = false
                i.items.forEach(item => {
                    item.plannedEndAt = item.plannedEndAt * 1000;
                    item.startAt = item.startAt * 1000;
                    item.extensionsItems = _self.getExtensions(item)
                    item.additionalsItems = _self.getAdditionals(item)
                    if(item.actualEndAt != null){
                        item.actualEndAt = item.actualEndAt * 1000;
                    }
                })

                i.historyItems.forEach(item => {
                    item.plannedEndAt = item.plannedEndAt * 1000;
                    item.startAt = item.startAt * 1000;
                    item.extensionsItems = _self.getExtensions(item)
                    item.additionalsItems = _self.getAdditionals(item)
                    if(item.actualEndAt != null){
                        item.actualEndAt = item.actualEndAt * 1000;
                    }
                })
            })
            _self.timedSlots = response.data
            if(_self.timedSlots.length === 1){
                _self.focusedSlotItem = _self.timedSlots[0].slot.id
            }
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getExtensions(item){
    if(item.extensions == null) return [];
    const raw = item.extensions;
    console.log(raw)
    if (Array.isArray(raw)) {
        return raw
            .map(x => (typeof x === 'string' ? x.trim() : x))
            .map(Number)
            .filter(n => Number.isFinite(n) && n > 0);
    }

    if (typeof raw === 'string') {
        return raw
            .split(';')
            .map(s => s.trim())
            .filter(Boolean)
            .map(Number)
            .filter(n => Number.isFinite(n) && n > 0);
    }

    return [];
}

function getAdditionals(item){
    if(item.additionals == null) return [];
    const raw = item.additionals;

    return raw
        .split(";")                // prvo split po ;
        .map(s => s.trim())
        .filter(Boolean)           // izbaci prazne
        .map(s => {
            const parts = s.split(":");
            return {
                id: parts[0].trim() || null,
                name: parts[1].trim() || null,
                price: parts.length > 2 ? parts[2].trim() || '0.00' : '0.00',
            };
        });
}

function addShopItemToSession(shopUuid, userId, id){
    let _self = this;
    let model = {
        userId: userId,
        slotTimedSessionId: id,
        shopUuid: shopUuid
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.addShopItemToSession(model)
        .then((response) => {
            _self.load()
            swal.close()
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/TimedSlot/TimedSlot.js